import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const HandThumbUpIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/hand-thumb-up"><g id="Icon"><path d="M1.19995 9.9002C1.19995 9.07177 1.87152 8.4002 2.69995 8.4002C3.52838 8.4002 4.19995 9.07177 4.19995 9.9002V18.9002C4.19995 19.7286 3.52838 20.4002 2.69995 20.4002C1.87152 20.4002 1.19995 19.7286 1.19995 18.9002V9.9002Z" fill="currentColor" /><path d="M13.2 3.6002V2.04038C13.2 1.71912 13.3676 1.40907 13.6739 1.31198C13.9029 1.23937 14.1469 1.2002 14.4 1.2002C15.7254 1.2002 16.8 2.27471 16.8 3.6002C16.8 4.79424 16.582 5.93737 16.1836 6.99195C15.9387 7.64039 16.3828 8.4002 17.076 8.4002H20.1C21.5911 8.4002 22.8133 9.61168 22.6754 11.0965C22.4437 13.5921 21.8935 15.9954 21.066 18.2653C20.5841 19.5872 19.2867 20.4002 17.8798 20.4002H14.0498C13.4909 20.4002 12.9397 20.2701 12.4398 20.0201L9.16008 18.3803C8.6602 18.1303 8.10899 18.0002 7.55011 18.0002H5.99995V9.6002H7.1558C7.97711 9.6002 8.66521 9.02117 9.09044 8.31851C9.6766 7.34996 10.5955 6.60528 11.6887 6.24294C12.208 6.07081 12.713 5.77934 12.9029 5.26623C13.095 4.74724 13.2 4.18597 13.2 3.6002Z" fill="currentColor" /></g></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default HandThumbUpIcon;